import { QueryKeys } from '@/configs/queryKeys';
import { Attachment, Translations } from '@/types/types';
import { Attribute } from './AttributeApi';
import EntityApi, { BaseEntity } from './EntityApi';
import { AttributeGroup } from '@/api/AttributeGroupApi';

export enum PriceType {
	FIXED = 'FIXED',
	PERCENTAGE = 'PERCENTAGE',
}

export interface AttributeValue extends BaseEntity {
	attribute: Attribute;
	value: string;
	displayName: string;
	description: string;
	priceType: PriceType;
	price: number;
	image: Attachment | null;
	group: AttributeGroup | null;
	listOrder: number;
	translations: Translations<{ displayName: string; description: string }>;
}

class AttributeValueApi extends EntityApi<AttributeValue> {
	constructor() {
		super(QueryKeys.attributeValues);
	}
}

export default new AttributeValueApi();
